import AccessTimeIcon from '@material-ui/icons/AccessTime';
import EventIcon from '@material-ui/icons/Event';
import { convertToFormatDate, convertToFormatTime } from '../../utils/dateFunctionUtils';
import { useStyles } from './DateTimeBar.styles';

interface DateTimeBarProps {
  expirationDate: string;
  dontDisplayTime?: boolean;
}

export default function DateTimeBar(props: DateTimeBarProps) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.textIcon}>
        <EventIcon
          style={{
            color: '#3C419A',
            padding: '0px',
            position: 'relative',
            marginRight: '6px',
            top: '6px',
          }}
        />
        {convertToFormatDate(props.expirationDate)}
        {!props.dontDisplayTime && (
          <AccessTimeIcon
            style={{
              color: '#3C419A',
              padding: '0px',
              position: 'relative',
              marginLeft: '20px',
              marginRight: '6px',
              top: '6px',
            }}
          />
        )}
        {!props.dontDisplayTime && convertToFormatTime(props.expirationDate)}
      </div>
    </>
  );
}
